import Immutable, { Map } from 'immutable'
import { combineActions, handleActions } from 'redux-actions'
import ActionHelper from 'helpers/action'
import { RESET_STORE } from 'constants/index'

// constants
export const TRANSLATION_LOGBOOK_EVENT_CATEGORY_FETCH_TABLE_DATA =
  'translations-logbook-event-category/TRANSLATION_LOGBOOK_EVENT_CATEGORY_FETCH_TABLE_DATA'
export const [
  TRANSLATION_LOGBOOK_EVENT_CATEGORY_FETCH_TABLE_DATA_SUCCESS,
  TRANSLATION_LOGBOOK_EVENT_CATEGORY_FETCH_TABLE_DATA_FAILURE,
] = [
  `${TRANSLATION_LOGBOOK_EVENT_CATEGORY_FETCH_TABLE_DATA}_SUCCESS`,
  `${TRANSLATION_LOGBOOK_EVENT_CATEGORY_FETCH_TABLE_DATA}_FAILURE`,
]
export const TRANSLATION_LOGBOOK_EVENT_CATEGORY_FETCH_FORM_DATA =
  'translations-logbook-event-category/TRANSLATION_LOGBOOK_EVENT_CATEGORY_FETCH_FORM_DATA'
export const [
  TRANSLATION_LOGBOOK_EVENT_CATEGORY_FETCH_FORM_DATA_SUCCESS,
  TRANSLATION_LOGBOOK_EVENT_CATEGORY_FETCH_FORM_DATA_FAILURE,
] = [
  `${TRANSLATION_LOGBOOK_EVENT_CATEGORY_FETCH_FORM_DATA}_SUCCESS`,
  `${TRANSLATION_LOGBOOK_EVENT_CATEGORY_FETCH_FORM_DATA}_FAILURE`,
]
export const TRANSLATION_LOGBOOK_EVENT_CATEGORY_CLEAR_STATE_LIST =
  'translations-logbook-event-category/TRANSLATION_LOGBOOK_EVENT_CATEGORY_CLEAR_STATE_LIST'
export const TRANSLATION_LOGBOOK_EVENT_CATEGORY_CLEAR_STATE_FORM =
  'translations-logbook-event-category/TRANSLATION_LOGBOOK_EVENT_CATEGORY_CLEAR_STATE_FORM'
export const TRANSLATION_LOGBOOK_EVENT_CATEGORY_CLEAR_STATE =
  'translations-logbook-event-category/CLEAR_STATE'
export const TRANSLATION_LOGBOOK_EVENT_CATEGORY_CHANGE =
  'translations-logbook-event-category/TRANSLATION_LOGBOOK_EVENT_CATEGORY_CHANGE'

// actions
export const translationsLogbookEventCategoryFetchTableData = ActionHelper.createActionObj(
  TRANSLATION_LOGBOOK_EVENT_CATEGORY_FETCH_TABLE_DATA,
)
export const translationsLogbookEventCategoryClearStateList = ActionHelper.createActionObj(
  TRANSLATION_LOGBOOK_EVENT_CATEGORY_CLEAR_STATE_LIST,
)
export const translationsLogbookEventCategoryClearState = ActionHelper.createActionObj(
  TRANSLATION_LOGBOOK_EVENT_CATEGORY_CLEAR_STATE_FORM,
)
export const translationsLogbookEventCategoryClearStateForm = ActionHelper.createActionObj(
  TRANSLATION_LOGBOOK_EVENT_CATEGORY_CLEAR_STATE,
)
export const translationsLogbookEventCategoryFetchFormData = ActionHelper.createActionObj(
  TRANSLATION_LOGBOOK_EVENT_CATEGORY_FETCH_FORM_DATA,
)
export const translationsLogbookEventCategoryChange = ActionHelper.createActionObj(
  TRANSLATION_LOGBOOK_EVENT_CATEGORY_CHANGE,
)

// store
const initialState = Immutable.fromJS({
  loading: true,
  tableData: {
    data: [],
    count: 0,
  },
  formData: {
    translations: [],
  },
})
const loadingActive = state => state.set('loading', true)

const logbookEventCategoryTranslations = handleActions(
  {
    [combineActions(
      TRANSLATION_LOGBOOK_EVENT_CATEGORY_FETCH_TABLE_DATA_SUCCESS,
      TRANSLATION_LOGBOOK_EVENT_CATEGORY_CHANGE,
    )]: loadingActive,
    [combineActions(
      TRANSLATION_LOGBOOK_EVENT_CATEGORY_CLEAR_STATE,
      RESET_STORE,
    )]: () => initialState,
    [TRANSLATION_LOGBOOK_EVENT_CATEGORY_FETCH_TABLE_DATA_SUCCESS]: (
      state,
      action,
    ) => state.set('tableData', Map(action.payload)),
    [TRANSLATION_LOGBOOK_EVENT_CATEGORY_FETCH_FORM_DATA_SUCCESS]: (
      state,
      action,
    ) => state.set('formData', Map(action.payload)),
  },
  initialState,
)

export default logbookEventCategoryTranslations
